export function UserStatusBadge({ active }: { active: boolean }): React.ReactElement {
  const style = active ? 'bg-green-100 text-green-800' : 'bg-muted text-muted-foreground'

  return <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium ${style}`}>{active ? 'Aktiv' : 'Inaktiv'}</span>
}
